import React, { useEffect, useState } from 'react'; //FB 6925 KK
import QRCode from "qrcode.react";
import Typography from "@material-ui/core/Typography";
import { Grid, Button, makeStyles } from "@material-ui/core";
import { useParams } from 'react-router-dom';
import { GetAdminSettingValue } from '../../../../../../api'; //FB 6925 KK

// Update log
// FB  6192   02/06/2023  DK  Page to display QR code for file upload via mobile
// FB  6925   06/06/2023  KK  Upload Doc (Use smartphone)> Updating the QR code with the Dynamic Link

export default function QRCodeComponent(props: any) {
    var doc_type = "";
    var encodedAppt_n = "";
    var decodedAppt_n = "";
    const { apptId } = useParams();
    if (apptId != undefined) {
        encodedAppt_n = apptId;
        decodedAppt_n = Buffer.from(encodedAppt_n, "base64").toString();
    }

    const { docType } = useParams();
    if (docType != undefined) {
        doc_type = docType;
    }

    //FB 6925 KK Begin
    const [category, setCategory] = useState('');
    const [portaldomain, setPortalDomain] = useState('');
    const [URL, setURL] = useState("");

    async function GetCategory() {
        const result = await GetAdminSettingValue("sms_to_mra_local_alias");
        if (result != null && result != "") {
            setCategory(result);
        }
        else {
            console.error('Error fetching admin setting:');
        }
    }
    async function GetPortalDomain() {
        const data = await GetAdminSettingValue("portal_domain");
        if (data != null && data != "") {
            setPortalDomain(data);
        }
        else {
            console.error('Error fetching admin setting:');
        }
    }
    useEffect(() => {
        GetCategory();
        GetPortalDomain();
    }, []);

    useEffect(() => {
        setURL(`https://${category}.${portaldomain}/user/fileupload/camera/` + decodedAppt_n + "/" + doc_type);
    }, [portaldomain]);
    // FB 6925 KK End

    return (
        <div>
            <Grid
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography variant="h6" component="legend">
                    Scan the below QR code to upload photos and close this tab once the file(s) uploaded
                </Typography>
            </Grid>
            <br />
            <br />
            <Grid
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {/* FB 6925 KK */}
                <QRCode value={URL} />  
            </Grid>
        </div>
    );
}